module.exports = __webpack_public_path__ + "img/risk_img_header@3x.4c3c1d46.png";